import React from 'react';

const PrivacyPolicyMatchemAllFruits = () => {
  const containerStyle = {
    padding: '20px',
    marginTop: '60px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  };

  const headerStyle = {
    color: '#111',
  };

  const paragraphStyle = {
    color: '#333',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

  return (
    <div style={containerStyle}>
        <h1 style={headerStyle}>Privacy Policy</h1>
        <p style={paragraphStyle}><strong>Effective Date:</strong> 31.07.2026</p>

        <p style={paragraphStyle}>At Match&apos;em All: Fruits, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share your data when you use our game.</p>

        <h2 style={headerStyle}>1. Data Collection</h2>
        <p style={paragraphStyle}>We do not collect any personal data directly. However, the game integrates with a third-party service that may collect data:</p>
        <ul>
            <li style={paragraphStyle}><strong>Firebase Analytics:</strong> For analytics and usage statistics.</li>
        </ul>
        <p style={paragraphStyle}>This service may collect data such as:</p>
        <ul>
            <li style={paragraphStyle}>Device information</li>
            <li style={paragraphStyle}>Usage statistics</li>
            <li style={paragraphStyle}>App interaction events</li>
        </ul>
        <p style={paragraphStyle}>Please refer to the <a style={linkStyle} href="https://firebase.google.com/support/privacy">Firebase Privacy Policy</a> for more details.</p>

        <h2 style={headerStyle}>2. Use of Data</h2>
        <p style={paragraphStyle}>Data collected by Firebase Analytics is used to:</p>
        <ul>
            <li style={paragraphStyle}>Understand how players use the game.</li>
            <li style={paragraphStyle}>Improve game performance and user experience.</li>
        </ul>

        <h2 style={headerStyle}>3. Data Sharing</h2>
        <p style={paragraphStyle}>We do not share your personal data with any other third parties. Data collected by Firebase Analytics is managed according to Google&apos;s privacy policies.</p>

        <h2 style={headerStyle}>4. Data Security</h2>
        <p style={paragraphStyle}>We take reasonable measures to protect your data from unauthorized access, but we cannot guarantee absolute security due to the inherent risks of digital data transmission.</p>

        <h2 style={headerStyle}>5. Children&apos;s Privacy</h2>
        <p style={paragraphStyle}>Match&apos;em All: Fruits is suitable for general audiences. We do not knowingly collect personal information from children. If you believe a child has provided personal data through the game, please contact us and we will take appropriate steps to address the issue.</p>

        <h2 style={headerStyle}>6. Changes to this Policy</h2>
        <p style={paragraphStyle}>We may update this Privacy Policy from time to time. Significant changes will be communicated through the game or our website.</p>

        <h2 style={headerStyle}>7. Contact Us</h2>
        <p style={paragraphStyle}>If you have any questions about this Privacy Policy, please contact us at <a style={linkStyle} href="mailto:reecomgamestudio@gmail.com">reecomgamestudio@gmail.com</a>.</p>
    </div>
  );
};

export default PrivacyPolicyMatchemAllFruits;
